<template>
  <div class="secondary-card">
    <SummaryCard :display="display" />

    <!-- Only the actions that can do something for THIS subscription. A
         fixed-term grant has no billing to change, so it gets none. -->
    <div v-if="!display.hidesBillingActions" class="secondary-card__actions">
      <ActionRow title="Update payment method" @select="$emit('update-payment')" />
      <ActionRow :title="cancelTitle" @select="$emit('cancel')" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import SummaryCard from "./SummaryCard.vue";
import ActionRow from "./ActionRow.vue";
import { storeLabelFor, type DisplayModel } from "../subscriptionLogic";

const props = defineProps<{ display: DisplayModel }>();
defineEmits<{ (e: "update-payment"): void; (e: "cancel"): void }>();

// Name the destination on a store-billed sub, because that is the whole point
// of the row: this is the one the user has to go elsewhere to stop.
const cancelTitle = computed(() => {
  if (props.display.pillState === "cancelled") return "View cancellation details";
  switch (props.display.source) {
    case "playstore":
    case "appstore":
      return `Cancel in the ${storeLabelFor(props.display.source)}`;
    default:
      return "Cancel this subscription";
  }
});
</script>

<style scoped lang="scss">
.secondary-card {
  &__actions {
    margin-top: 0.5rem;
  }
}
</style>
